export default __webpack_public_path__ + "static/media/solana-step-loading.d67260bf.svg";